export const UNCATEGORIZED_GROUP_NAME = 'Uncategorized Group'; // This needs to remain in sync with server/constants/projects.ts:UNCATEGORIZED_GROUP_NAME
export const DUPLICATE_GROUP_NAME_ERROR = 'This project already has a group by that name.';
export const DUPLICATE_CUSTOM_GROUP_ERROR = 'This custom group has already been created.';
export const PROJECT_NAME_INVALID_ERROR = 'Only alphanumeric characters and certain special characters are allowed';
export const PROJECT_NAME_LENGTH_ERROR = 'Name must not be more than 100 characters';
export const PROJECT_DESCRIPTION_LENGTH_ERROR = 'Description must not be more than 100 characters';

export const MAX_PROJECT_NAME_LENGTH = 100;
export const MAX_PROJECT_GROUP_NAME_LENGTH = 100;
export const COMMENT_MAX_LENGTH = 500;

export enum ProjectSuccessActions {
	COPY = 'COPY',
	MOVE = 'MOVE',
	SAVE = 'SAVE',
	ATTACH = 'ATTACH'
}

export enum ToolBarActions {
	SELECT_ALL = 'Select All',
	CLEAR_ALL = 'Deselect All',
	COPY = 'Copy',
	MOVE = 'Move',
	COMPARE = 'Compare',
	DELETE = 'Delete',
	ADD_TO_CART = 'Add to Cart',
	NEW_GROUP = 'New Group',
	TOOLS = 'Tools',
	FILTER = 'Filter',
	COLLAPSE_ALL = 'Collapse All'
}

export const BID_ALREADY_EXISTS_ERROR = 'This Bid is already included in this Project.';
export const BID_GENERIC_ERROR = 'Please check the information you’ve entered and try again.';
export const BID_NO_PRODUCTS_ERROR = 'No Valid Products: The identified bid is empty, please check your details and try again.';

export const searchIconClass = 'right-1 absolute f3 theme-grey';
export const searchInputClass = 'pl3 pr6';

export const EXAMPLE_PROJECT_ID = 7159844;

export const DEFAULT_PROJECTS_TITLE = 'Project Tool';

export const PRO_PROJECTS_TITLE = 'Streamline Your Business';
